import { isCookieSet, removeCookie, setCookie } from './cookie';
import { UsajConfig, UserObject } from '../interfaces';

function isHostUsajobs(value: string) {
    if (value === '') { return true; }
    let url = document.createElement('a');
    url.href = value;
    return url.hostname.lastIndexOf('www.usajobs.gov') > -1 || url.hostname.lastIndexOf('localhost') > -1;
}

async function initUserObject() {
    const url = '/Account/RetrieveUserPreferences';

    return fetch(url, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 'referrer': document.referrer })
    })
        .then(response => response.text())
        .then(data => {
            let userObject = <UserObject>JSON.parse(data);
            userObject.LastLoad = new Date().getTime();
            if (userObject.AssignedFeatures.length > 0) {
                setCookie('usaj-f', JSON.stringify(userObject.AssignedFeatures));
            }
            setUserObject(userObject);
        }).catch(err => console.debug('Error', err));
}

async function setUsajConfig() {
    const url = '/Client/GetClientConfigAsJson';

    return fetch(url)
        .then(response => response.text())
        .then(data => {
            let usajConfig = JSON.parse(data);
            sessionStorage.setItem('usajConfig', usajConfig['value'] === undefined ? usajConfig : usajConfig['value']);
        }).catch(err => console.debug('Error', err));
}

export function getUsajConfig(): UsajConfig {
    return <UsajConfig>JSON.parse(sessionStorage.getItem('usajConfig') || '{}');
}

export function setUserObject(userObject: UserObject) {
    sessionStorage.setItem('userObject', JSON.stringify(userObject));
    dispatchEvent(new Event('userObjectChanged'));
}

export function getUserObject(): UserObject {
    return <UserObject>JSON.parse(sessionStorage.getItem('userObject') || '{}');
}

export function getCEResponsesData(): UserObject {
    return <UserObject>JSON.parse(sessionStorage.getItem('CEResponsesData') || '{}');
}

export function addSavedJobToSession(documentId: string) {
    let uo = getUserObject();
    uo.SavedJobs[documentId] = true;
}

export function removeSavedJobFromSession(documentId: string) {
    let uo = getUserObject();
    delete uo.SavedJobs[documentId];
}

export function isAuthenticated() {
    let uo = getUserObject();
    if (uo === null) { return false; }
    return uo.IsAuthenticated;
}

export function logout() {
    localStorage.setItem('usaj-l', 'false');
    removeCookie('usaj-cid');
    sessionStorage.removeItem('dismissedAlerts');
    sessionStorage.removeItem('usajConfig');
    sessionStorage.removeItem('userObject');
    location.href = '/Account/Logoff';
}

export async function initSession() {
    if (sessionStorage.getItem('dismissedAlerts') === null) {
        sessionStorage.setItem('dismissedAlerts', '{}');
    }
    if (sessionStorage.getItem("xSource") === null) {
        sessionStorage.setItem("xSource", document.referrer);
    }
    let currentxSource = sessionStorage.getItem("xSource") || '';
    if (currentxSource !== document.referrer && isHostUsajobs(currentxSource) && !isHostUsajobs(document.referrer)) {
        sessionStorage.setItem("xSource", document.referrer);
    }
    if (sessionStorage.getItem("userObject") === null || sessionStorage.getItem('usajConfig') === null || isCookieSet("usaj-u")) {
        window.localStorage.setItem("usaj-l", 'true');
        removeCookie('usaj-u');
        await initUserObject().then();
        await setUsajConfig().then();
    }

    window.addEventListener('storage', evt => {
        if (evt.key === "usaj-l" && evt.newValue === "false") { logout(); }
    }, false);

    document.dispatchEvent(new Event("session-loaded"));
}
